import { render, staticRenderFns } from "./TitleBase.vue?vue&type=template&id=5fea7d3d&scoped=true&"
import script from "./TitleBase.vue?vue&type=script&lang=js&"
export * from "./TitleBase.vue?vue&type=script&lang=js&"
import style0 from "./TitleBase.vue?vue&type=style&index=0&id=5fea7d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea7d3d",
  null
  
)

export default component.exports